import { useTranslation } from 'react-i18next';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import PageTitle from '@/components/ui/custom/PageTitle';
import Layout from '@/components/template/Layout';
import KlassProgressTable from '@/components/admin/klassesTable/KlassProgressTable';
import InfiniteSearchInput from '@/components/ui/custom/dataInput/InfiniteSearchInput';
import { translateKlassName } from '@/utils/translateKlassName';
import { getAuthorizedUnits } from '@/utils/getAuthorizedUnits';
import useAuth from '@/data/hook/useAuth';
import { REQUEST_STALE_TIME_IN_MS as staleTime } from '@/constants';
import { klassesQueryKeys } from '@/data/services/querykeys';
import HideForMobile from '@/components/ui/custom/HideForMobile';

export default function KlassProgressView() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'klassProgressPage',
  });

  const { user } = useAuth();

  const navigate = useNavigate();

  const { klassId: id } = useParams();

  const klassId = Number(id);

  const enabled = !isNaN(klassId);

  const options = {
    enabled,
    staleTime,
  };

  const {
    data: klass,
    isInitialLoading,
    error,
  } = useQuery({
    ...klassesQueryKeys.get(klassId),
    ...options,
    retry: false,
  });

  return (
    <Layout>
      <HideForMobile>
        <main className="flex gap-2.5 flex-col">
          <PageTitle headingText={t('pageTitle')} backButton position="mb-0" />
          <InfiniteSearchInput
            service={klassesQueryKeys.list}
            filters={{ unitId: getAuthorizedUnits(user) }}
            displayName={klass => translateKlassName(klass.name)}
            onSelect={klass => navigate(`/class/${klass.id}/progress`)}
            selectedItem={klass}
            blockDeselect
            input={{ className: { base: 'w-96 font-500' } }}
          />

          <KlassProgressTable
            key={klassId}
            klass={klass}
            error={error}
            loading={isInitialLoading}
          />
        </main>
      </HideForMobile>
    </Layout>
  );
}
